module.exports = __webpack_public_path__ + "static/media/home.d33867ad.jpg";